import { AppNotification } from '../types';

export const VERIFY_EMAIL_ERROR_OBJECT: AppNotification = {
  message: 'Please verify your email.',
  options: {
    permanent: true,
    variant: 'error',
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    action: {
      type: 'verify_email',
      buttonText: 'Resend verification link',
    },
  },
  description: 'Click on the link in the email we’ve just sent you. ',
};
